import { memo } from "react"
import { BRACKY_ANIMATION_URLS } from "../data/bracky-animation-urls"
import type { BrackyAnimationState } from "../hooks/use-bracky-animations"

interface BrackyAvatarImageProps {
  state: BrackyAnimationState
}

function getAnimationUrl(state: BrackyAnimationState): string {
  if (state.showInitialWinkAnimation) return BRACKY_ANIMATION_URLS.winkInitial
  if (state.showSideEyeAnimation) return BRACKY_ANIMATION_URLS.sideEye
  if (state.isDoubleNodding) return BRACKY_ANIMATION_URLS.doubleNod
  if (state.isWinking3D) return BRACKY_ANIMATION_URLS.wink3D
  if (state.isShocked) return BRACKY_ANIMATION_URLS.shocked
  if (state.showWinkAnimation) return BRACKY_ANIMATION_URLS.lookRight
  if (state.isBrackyPressed) return BRACKY_ANIMATION_URLS.wincePressed
  if (state.isBrackyHovered) return BRACKY_ANIMATION_URLS.winceHover
  return BRACKY_ANIMATION_URLS.default
}

export const BrackyAvatarImage = memo(function BrackyAvatarImage({ state }: BrackyAvatarImageProps) {
  return (
    <>
      <div className="absolute w-[2.78rem] h-[2.78rem] rounded-full bg-[#0000ff] z-0" aria-hidden="true" />
      <img
        src={getAnimationUrl(state)}
        alt="Bracky"
        className="w-[2.78rem] h-[2.78rem] rounded-full relative z-10 select-none pointer-events-none drop-shadow-xs"
        draggable="false"
        style={{
          userSelect: "none",
          WebkitUserSelect: "none",
        }}
      />
      <div
        className="w-[2.78rem] h-[2.78rem] rounded-full border-2 border-white/50 blur-[2px] absolute top-0 left-0 z-20 pointer-events-none"
        style={{
          maskImage: "radial-gradient(circle, white 0%, white 85%, transparent 85%)",
          WebkitMaskImage: "radial-gradient(circle, white 0%, white 85%, transparent 85%)",
        }}
        aria-hidden="true"
      />
    </>
  )
})
